import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
//custom imports
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import LoginHistory from "./loginHistory"
//import Actions from "./components/Actions";
//import TabPanel from "./components/Tab"
function LoginDetails() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
            <LoginHistory/>
      <Footer />
    </DashboardLayout>
  );
}
export default LoginDetails;
